// Statuses that should be filtered out from alpha and beta features
export const EXCLUDED_ROLLOUT_STATUSES = [
  'Ramping',
  '100% Released',
  'Removed From Code',
  'killed',
].map((status) => status.toLowerCase())
